export default "__VITE_ASSET__f3adb457__"